module.exports = __webpack_public_path__ + "img/ys.cad28083.png";